
function disableNoJsInputs(root = document) {
  const noJsInputs = root.querySelectorAll('ul.no-js input[type="checkbox"], ul.no-js input[type="radio"]');
  noJsInputs.forEach((el) => {
    el.disabled = true;
  });
  if (noJsInputs.length) {
    console.log(`[disableNoJsInputs] disabled ${noJsInputs.length} .no-js fallback inputs in`, root === document ? 'document' : root);
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    } else {
      console.warn('[FacetFiltersForm] No <form> found inside facet-filters-form element', this);
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Disable no-js fallback checkboxes for this instance on initial load
    disableNoJsInputs(this);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
     // console.log('[FacetFiltersForm] popstate triggered, re-rendering with params:', searchParams);
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    const elements = document.querySelectorAll('.js-facet-remove');
    // console.log(`[toggleActiveFacets] disable=${disable}, found ${elements.length} .js-facet-remove elements`);
    elements.forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
   // console.log('[renderPage] called with searchParams:', searchParams, 'event:', event);
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');

    if (gridContainer) {
      const collectionEl = gridContainer.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading');
    } else {
      console.warn('[renderPage] #ProductGridContainer not found in DOM');
    }

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
    //  console.log('[renderPage] fetching/using section URL:', url);
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
  //  console.log('[renderSectionFromFetch] fetching:', url);
    fetch(url)
      .then(response => {
        if (!response.ok) {
          console.error('[renderSectionFromFetch] fetch failed with status', response.status, url);
        }
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      //  console.log('[renderSectionFromFetch] response received, rendering filters/grid/count');
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        /***** Collection page featured products slider ****/
        if ($('.col-featured-mobile-slider').length > 0) {
          $('.col-featured-mobile-slider').flickity({
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            wrapAround: false,
            adaptiveHeight: false,
            lazyLoad: true,
            watchCSS: true,
            arrowShape: 'M6.00002 12.5151L5.22224 11.7007L9.79632 7.02271H0.0740967V5.88634H9.79632L5.22224 1.20831L6.00002 0.393921L11.9259 6.45453L6.00002 12.5151Z',
            on: {
              ready: function () {
                $('.flickity-button svg').attr('viewBox', '0 0 12 13');
                $('.flickity-button.flickity-prev-next-button svg path').removeAttr('transform');
              }
            }
          });
        }
        /***** Collection page featured products slider END HERE ****/

        // Re-disable no-js checkboxes for freshly injected HTML
        disableNoJsInputs(document);
      })
      .catch((err) => {
        console.error('[renderSectionFromFetch] error during fetch/render:', err);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const found = FacetFiltersForm.filterData.find(filterDataUrl);
    if (!found) {
      console.warn('[renderSectionFromCache] no cached data found for this URL');
      return;
    }
  //  console.log('[renderSectionFromCache] using cached HTML');
    const html = found.html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    disableNoJsInputs(document);
  }

  static renderProductGridContainer(html) {
    const currentGrid = document.getElementById('ProductGridContainer');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = parsed.getElementById('ProductGridContainer');

    if (!currentGrid) {
     // console.error('[renderProductGridContainer] #ProductGridContainer not found in current DOM');
      return;
    }
    if (!newGrid) {
    //  console.error('[renderProductGridContainer] #ProductGridContainer not found in fetched HTML');
      return;
    }

    currentGrid.innerHTML = newGrid.innerHTML;
   // console.log('[renderProductGridContainer] grid updated');

    const currentSort = new URLSearchParams(window.location.search).get('sort_by');
    if (currentSort) {
    //  console.log('[renderProductGridContainer] re-applying sort:', currentSort);
      setTimeout(function () {
        sortVariantProducts(currentSort);
      }, 100);
    }
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedHTML.getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (!sourceCount) {
   //   console.warn('[renderProductCount] #ProductCount not found in fetched HTML');
      return;
    }
    if (container) {
      container.innerHTML = sourceCount.innerHTML;
      container.classList.remove('loading');
    } else {
     // console.warn('[renderProductCount] #ProductCount not found in current DOM');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = sourceCount.innerHTML;
      containerDesktop.classList.remove('loading');
      const searchCount = document.getElementsByClassName('search_count')[0];
      if (searchCount) {
        searchCount.innerHTML = sourceCount.innerHTML;
      } else {
      //  console.warn('[renderProductCount] .search_count element not found');
      }
    }
   // console.log('[renderProductCount] count updated');
  }

  static renderFilters(html, event) {
  //  console.log('[renderFilters] start, event:', event);
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');

  //  console.log(`[renderFilters] found ${facetDetailsElements.length} .js-filter elements in fetched HTML`);

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) {
        target.innerHTML = element.innerHTML;
      } else {
        console.warn(`[renderFilters] no matching element in current DOM for data-index="${element.dataset.index}" — skipped`);
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const targetFilter = event && event.target ? event.target.closest('.js-filter') : null;
      if (targetFilter) {
        FacetFiltersForm.renderCounts(countsToRender, targetFilter);
      } else {
        console.warn('[renderFilters] countsToRender exists but could not find event.target.closest(".js-filter")');
      }
    }
   // console.log('[renderFilters] done');
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentEl = document.querySelector(selector);

      if (!activeFacetsElement) {
      //  console.warn(`[renderActiveFacets] "${selector}" not found in fetched HTML`);
        return;
      }
      if (!currentEl) {
      //  console.warn(`[renderActiveFacets] "${selector}" not found in current DOM`);
        return;
      }

      currentEl.innerHTML = activeFacetsElement.innerHTML;
   //   console.log(`[renderActiveFacets] updated "${selector}"`);
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const src = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!src) return;
      if (!target) {
        // console.warn(`[renderAdditionalElements] "${selector}" not found in current DOM`);
        return;
      }
      target.innerHTML = src.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const menuDrawer = mobileForm.closest('menu-drawer');
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
        menuDrawer.bindEvents();
      } else {
       // console.warn('[renderAdditionalElements] menu-drawer or bindEvents() not found');
      }
    } else {
     // console.warn('[renderAdditionalElements] #FacetFiltersFormMobile not found in current DOM');
    }
  }

  static renderCounts(source, target) {
    if (!source || !target) {
    //  console.warn('[renderCounts] missing source or target', { source, target });
      return;
    }

    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      targetElement.outerHTML = sourceElement.outerHTML;
    } else {
     // console.warn('[renderCounts] .facets__selected missing on source or target');
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      targetElementAccessibility.outerHTML = sourceElementAccessibility.outerHTML;
    } else {
     // console.warn('[renderCounts] .facets__summary missing on source or target');
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
   // console.log('[updateURLHash] URL updated to:', window.location.href);
  }

  static getSections() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
     // console.error('[getSections] #product-grid not found — renderPage cannot build fetch URL correctly');
      return [{ section: '' }];
    }
    return [
      {
        section: grid.dataset.id,
      }
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);

    // Extra safety net: dedupe identical key=value pairs even if a stray
    // duplicate checkbox slips through, so the same value is never sent twice.
    const seen = new Set();
    const deduped = new URLSearchParams();
    for (const [key, value] of params.entries()) {
      const uniqueKey = `${key}=${value}`;
      if (!seen.has(uniqueKey)) {
        seen.add(uniqueKey);
        deduped.append(key, value);
      }
    }

    const result = deduped.toString();
   // console.log('[createSearchParams] form:', form.id, '→ params:', result);
    return result;
  }

  onSubmitForm(searchParams, event) {
    var params = searchParams;
    if ($.trim($('input[name="filter.v.price.gte"]').val()) == '' && $.trim($('input[name="filter.v.price.lte"]').val()) == '') {
      var urlParts = searchParams;
      var params = new URLSearchParams(urlParts);
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      params = params.toString();
    }

  //  console.log('[onSubmitForm] final params sent to renderPage:', params);
    FacetFiltersForm.renderPage(params, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
 //   console.log('[onSubmitHandler] triggered by:', event.target);

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
 //   console.log('[onActiveFilterClick] clicked remove for:', event.currentTarget.href);
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (!minInput || !maxInput) {
   //   console.warn('[PriceRange] expected 2 inputs, found', inputs.length);
      return;
    }
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (!facetLink) {
   //   console.warn('[FacetRemove] no <a> found inside facet-remove element', this);
      return;
    }
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (!form) {
    //  console.error('[FacetRemove] no facet-filters-form element found anywhere in DOM');
      return;
    }
  //  console.log('[FacetRemove] closeFilter called, using form:', form);
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function sortVariantProducts(sortType) {
  const grid = document.querySelector('#product-grid');
  if (!grid) {
  //  console.warn('[sortVariantProducts] #product-grid not found, cannot sort');
    return;
  }

  const items = [...grid.querySelectorAll('.grid__item')];
 // console.log(`[sortVariantProducts] sorting ${items.length} items by "${sortType}"`);

  items.sort((a, b) => {
    const priceA = Number(a.dataset.price || 0);
    const priceB = Number(b.dataset.price || 0);
    const titleA = (a.dataset.title || '').toLowerCase();
    const titleB = (b.dataset.title || '').toLowerCase();

    if (sortType === 'price-ascending') return priceA - priceB;
    if (sortType === 'price-descending') return priceB - priceA;
    if (sortType === 'title-ascending') return titleA.localeCompare(titleB);
    if (sortType === 'title-descending') return titleB.localeCompare(titleA);
    return 0;
  });

  items.forEach(item => {
    grid.appendChild(item);
  });

 // console.log('[sortVariantProducts] sort complete');
}

document.addEventListener('change', function (event) {
  if (event.target.id !== 'SortBy') return;
 // console.log('[SortBy change] value:', event.target.value);
  setTimeout(function () {
    sortVariantProducts(event.target.value);
  }, 1200);
});

// Initial page load — disable any .no-js fallback checkboxes present at start
document.addEventListener('DOMContentLoaded', () => disableNoJsInputs(document));
document.addEventListener('DOMContentLoaded', function () {
  const initialSort = new URLSearchParams(window.location.search).get('sort_by');
 // console.log('[DOMContentLoaded] initial sort_by from URL:', initialSort);
  if (initialSort) {
    sortVariantProducts(initialSort);
  }
});